/**************************************************
 * Nombre:       Seccion_Despachos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import React, {useContext, useEffect, useRef, useState} from "react";
import {useObtenerAlto} from "../../Modulo_Graficas/Hooks/useObtenerAlto";
import Titulo_Dos_Datos from "../../Modulo_Graficas/Componentes/Titulos/Titulo_Dos_Datos";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import Tarjeta_Indicador from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Indicador";
import {usuarioContext} from "../../App";
import {theme} from "../../Tema";
import {TEXTO} from "../../Modulo_Dashboard/ContantesColor";
import ListaFunnels from "./Componentes/ListaFunnels";
import {obtenerSaldo} from "../../CodNegocio/Saldos/obtenerSaldo";
import {contarWheres} from "../../Servicios/BD/Contadores/contarWheres";
import {where} from "firebase/firestore";
import {ESTADOSCAMPANAS} from "../../Constantes";
import {Campaign, WalletOutlined} from '@mui/icons-material'
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";


const Seccion_Funnel_Dahsboard = () => {
    const cData = useContext(usuarioContext)
    const {sCell} = useResponsive()
    const refe = useRef()
    const altoGraficas = 190
    const {alto} = useObtenerAlto({contenedor: refe})
    const [usuario, setUsuario] = useState({})
    const [numCampanas, setNumCampanas] = useState(0)
    const [numSaldo, setNumSaldo] = useState(0)
    const [cargar, setCargar] = useState(false)
    const [datos, setDatos] = useState({})

    const realizado = () => {
        console.log('realiza')
        setCargar(!cargar)
    }

    const obtenerDatos = async () => {

        const idUsuario = cData.usuario.id
        let numSaldo = await obtenerSaldo({idUsuario: idUsuario})
        setNumSaldo(numSaldo)

        let w = [where('estado', '==', ESTADOSCAMPANAS[1].nombre)]
        const numCampanas = await contarWheres({coleccion: 'campanas', wheres: w})
        setNumCampanas(numCampanas.data)

        let wLeads = [where('idUsuario', '==', idUsuario)]
        let numLeads = await contarWheres({coleccion: 'leads', wheres: wLeads})

        let inicioMes = new Date()
        inicioMes.setDate(1)
        inicioMes.getTime()

        let wLeadsMes = [where('idUsuario', '==', idUsuario), where('fecha', '<', inicioMes.getTime())]
        let numLeadsMes = await contarWheres({coleccion: 'leads', wheres: wLeadsMes})


        let obj = {
            numLeads: numLeads.data ? numLeads.data : 0,
            numLeadsMes: numLeadsMes.data ? numLeadsMes.data : 0,
        }

        setDatos(obj)

    }

    useEffect(() => {

        if (cData.usuario) {
            setUsuario(cData.usuario)
        }

        obtenerDatos().then((data) => {
        })


    }, [cData, cargar]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px', pb: 6}}
                spacing={4}
            >


                <Grid ref={refe} container size={{xs: 12, sm: 12, md: 8}}
                      sx={{height: altoGraficas, mb: sCell ? 21 : 0}}>
                    <Titulo_Dos_Datos titulo={`Hola ${usuario?.nombres}!`}
                                      textoUno={'Leads Totales'}
                                      textoDos={'Leads Mes'}
                                      datoUno={datos.numLeads}
                                      datoTres={datos.numLeadsMes}

                    />
                </Grid>


                <Grid container size={{xs: 6, sm: 3, md: 2}} sx={{height: alto}}>
                    <Tarjeta_Indicador
                        icono={<Campaign sx={{width: 50, height: 50, fill: theme.palette.primary.main}}/>}
                        titulo={'Funnels Activos'}
                        valor={numCampanas}/>
                </Grid>

                <Grid container size={{xs: 6, sm: 3, md: 2}} sx={{height: alto}}>
                    <Tarjeta_Indicador
                        icono={<WalletOutlined sx={{width: 50, height: 50, fill: '#7E7850'}}/>}
                        color={'#7E7850'} titulo={'Saldo Actual'}
                        valor={formatoMonedaTabla(numSaldo)}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{
                          justifyContent: 'flex-start',
                          backgroundColor: theme.palette.primary.main + 10,
                          p: 2,
                          borderRadius: 1,
                      }}>
                    <Typography sx={{color: TEXTO, fontSize: 18, fontWeight: 600}}>Funnels Disponibles</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <ListaFunnels realizado={realizado} cargar={cargar}/>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Funnel_Dahsboard

